export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    console.log('hello')
  },
};



// WEBPACK FOOTER //
// resources/assets/scripts/routes/home.js